'use strict';

AwsS3MultiFileService.$inject = [
  '$http',
  '$download',
  'FirebaseUtil',
  'AwsS3GatewayService',
];

/**
 * bind to the task location
 *  report progress to the task
 *  retrieve the final task data (get/head URLs) when the task is complete
 *  make an exponential backoff request to head until the file is available
 *  download the file
 */
export function AwsS3MultiFileService($http, $download, FirebaseUtil, AwsS3GatewayService) {
  var taskCollection = '_zip-list-progress/tasks';
  var tasksRef = FirebaseUtil.firebaseRef(taskCollection);
  var currentTasks = {};

  this.create = create;

  function create(task, noteDeferred) {
    var observer = new TaskObserver(task, noteDeferred);
    var listener = createListener(observer);
    var taskRef = tasksRef.child(observer.zipKey);
    taskRef.on('value', listener, function (e) {
      console.error(e);
      observer.deferred.reject(e)
    });
    currentTasks[task.zipKey] = listener;
    observer.cleanup = function () {
      taskRef.off('value', listener);
    };
    return observer.deferred.promise;
  }

  function TaskObserver(task, noteDeferred) {
    this.zipKey = task.zipKey;
    this.fileName = task.fileName;
    this.deferred = noteDeferred || Promise.defer();
  }

  TaskObserver.prototype.performDownload = performDownload;

  function performDownload(getUrl, headUrl) {
    var self = this;
    var existsRequest = {
      method: 'HEAD',
      url: headUrl
    };

    AwsS3GatewayService.doExpBackoff(__sendRequest, 5, 250)
      .then(__download, self.deferred.reject.bind(self.deferred));

    function __sendRequest() {
      return $http(existsRequest);
    }

    function __download(result) {
      if (result.status === 200) {
        self.deferred.resolve(null); // TODO: send message here
        try {
          return $download.promptDownload(getUrl, self.fileName);
        } catch (e) {
          console.error(e);
        }
      } else {
        self.deferred.reject(null); // TODO: send message here
        // TODO: update the message in the notification panel and change it to not auto-remove
        $toast.showI18nMessage({
          messageId: 'files.not.found.message',
          type: 'info'
        });
      }
    }
  }

  /**
   *
   * @param {TaskObserver} task
   * @returns {onUpdate}
   */
  function createListener(task) {
    return function onUpdate(ss) {
      if (!ss.exists()) {
        // TODO: handle problem
      } else {
        var value = ss.val();

        if (value._state === 'in_progress') {
          task.deferred.progress(value.progress);
        } else if (value._state === 'complete') {
          task.deferred.progress(100);
          task.cleanup();
          task.performDownload(value.getUrl, value.headUrl);
        } else if (value._state === 'error') {
          task.cleanup();
          task.deferred.reject();
        } else {
          // this shouldn't happen should it?
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/core-utilities/aws-api/AwsS3MultiFileService.js